const BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL_BROKER = process.env.REACT_APP_API_URL;

const STATUS_FAILED = 'Failed';
const STATUS_SUCCESS = 'Success';

export default {
  BASE_URL,
  BASE_URL_BROKER,
  STATUS_FAILED,
  STATUS_SUCCESS,
};
